import React, { useEffect, useState, useMemo } from "react";
import { showProviderApi } from "../../../../services/Admin/provider";
import useAuth from "../../../../hooks/useAuth";
import TableC from "../../../../components/Admin/TableC";
import {Grid, Box, Button, Link} from "@mui/material";
import LoadingProgress from "../../../../components/LoadingProgress";
import {RouteAdmin} from "../../../../routes/RouteAdmin";
import Card from "../../../../components/Admin/Card";

export default function Management() {

    const [servicios, setServicios] = useState(null)
    const [loading, setLoading] = useState(true)
    const [globalFilter, setGlobalFilter] = useState("")

    const columns = useMemo(
        () => [
            {
                Header: "NOMBRE / RAZÓN SOCIAL",
                accessor: "name",
            },
            {
                Header: "CIF / NIF",
                accessor: "nif",
            },
            {
                Header: "IRPF",
                accessor: "isIrpf_html",
            },
            {
                Header: "% IRPF",
                accessor: "irpf",
            },
            {
                Header: "ACCIONES",
                accessor: "actions",
            }
        ],
        []
    )

    useEffect(() => {
       getProviders()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const getProviders = async () =>{
        setLoading(true)

        showProviderApi().then(resp => {
            const temp = resp.data.data.map((doc) => {
                let href = `${RouteAdmin.PROVIDER_EDIT.path}/${doc.id}`;
                var isIrpf = "No";
                if (doc.isIrpf) {
                    isIrpf = "Sí";
                }

                return {
                    id: doc.id,
                    name: doc.name,
                    nif: doc.nif,
                    isIrpf_html: isIrpf,
                    actions: (
                        <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            href={href}
                            sx={{
                                borderRadius: 2,
                                paddingLeft: 2,
                                paddingRight: 2,
                                textTransform: 'none',
                                fontWeight: 500,
                                boxShadow: 'none'
                            }}
                        >
                            Editar
                        </Button>
                    ),
                    ...doc,
                }
            })
            setServicios(temp)
            setLoading(false)
        }).catch(err => {
            console.error(err)
        })
    }

    // --- Filtro global aplicado a servicios ---
    const filteredServicios = useMemo(() => {
        if (!globalFilter) return servicios || [];
        const search = globalFilter.toLowerCase();
        return (servicios || []).filter(row =>
            Object.values(row).some(
                val =>
                    typeof val === 'string' && val.toLowerCase().includes(search)
            )
        );
    }, [servicios, globalFilter]);

    return (
        <Card>
            <div className="cointainer cointainer-bt">
                <h1>Proveedores</h1>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', height: '100%' }}>
                    <Button
                        variant="outlined"
                        color="primary"
                        style={{ width: 200 }}
                        href={RouteAdmin.PROVIDER_CREATE.path}
                    >
                        Añadir
                    </Button>
                </div>
            </div>

            <LoadingProgress loading={loading}/>
            {!loading && (
                <TableC
                    columns={columns}
                    data={filteredServicios}
                    globalFilter={globalFilter}
                    setGlobalFilter={setGlobalFilter}
                />
            )}
        </Card>
    )
}
